import React from 'react'
import { TouchableOpacity, View } from 'react-native'
import { useNavigation } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Icon, Text } from '@src/components/base'
import { AppStackParamList } from '@src/navigation/types'
import { useLazyScreenPreload } from '@src/navigation/utils'

export interface LabResultCardProps {
  date: string
  createdAt: string
  id: string
}

export const LabResultCard = ({ date, createdAt, id }: LabResultCardProps) => {
  const styles = useStyleSheet(themedStyles)
  const navigation = useNavigation<StackNavigationProp<AppStackParamList>>()
  useLazyScreenPreload('LabResultDetail')

  const onPress = () => {
    navigation.navigate('LabResultDetail', { id })
  }

  return (
    <TouchableOpacity onPress={onPress} accessibilityLabel="View lab result details">
      <View style={styles.container}>
        <View style={styles.descriptors}>
          <Text type="large">{date}</Text>
          <Text type="regular" style={styles.secondaryText}>
            Created at: {createdAt}
          </Text>
        </View>
        <View style={styles.spacing} />
        <Icon name="caret-right" size={20} />
      </View>
    </TouchableOpacity>
  )
}

const themedStyles = StyleService.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 24,
    backgroundColor: 'theme.background.selected',
    borderRadius: 12,
    borderWidth: 1,
    borderColor: 'theme.surface.base',
  },
  descriptors: {
    flexDirection: 'column',
  },
  secondaryText: {
    color: 'theme.text.tertiary',
  },
  spacing: {
    flex: 1,
  },
})
